<app-card label="Contact Your Care Team">
  Use the <a class="dead-link" (click)="onSecureMailLinkClick()">Secure Mail</a> area to send message directly to your Care Team.
</app-card>